import { PencilSimpleIcon } from '@phosphor-icons/react'

import { helpers } from '@reveni-io/reveni-ui'

import { statuses } from '@/returns/constants'
import { getConceptAmountsPayload } from '@/returns/helpers/helpers'

import { rejectionWarningMessages } from './constants'
import * as Styles from './styles'

export const getLineItemsToValidate = lineItems => {
  return lineItems
    ?.filter(lineItem => [statuses.inProgress, statuses.forReview].includes(lineItem.status))
    .map(item => ({
      ...item,
      cancelled_from_draft: false,
      exchange_info: null,
    }))
}

export const getRejectedLineItemIds = lineItemsToReject => {
  if (!lineItemsToReject?.length) return []

  return lineItemsToReject.map(item => helpers.getOriginalId(item.id))
}

export const areAllItemsToValidateInProgress = lineItems => {
  const itemsToValidate = getLineItemsToValidate(lineItems)

  return itemsToValidate.length > 0 && itemsToValidate.every(item => item.newStatus === statuses.inProgress)
}

export const getPartialValidationPayload = ({
  lineItems,
  issueRefund,
  restock,
  restockLocation,
  issueExchangeOrderProcessing,
  numberOfNewAcceptedItems,
  concepts,
  note,
  refundMethod,
  totalAmount,
  shouldSendModifications,
}) => {
  const payload = {
    items: lineItems
      ?.flatMap(item => {
        if (item?.bundleItems?.length) {
          return [item, ...item.bundleItems]
        }
        return item
      })
      ?.filter(item => [statuses.accepted, statuses.rejected, statuses.forReview].includes(item.newStatus))
      ?.map(item => ({
        item_id: helpers.getOriginalId(item.id),
        status: item.newStatus,
        reject_reason: item.newStatus === statuses.rejected ? item.reject_reason : undefined,
        reject_reason_text: item.newStatus === statuses.rejected ? item.reject_reason_text : undefined,
        for_review_reason: item.newStatus === statuses.forReview ? item.for_review_reason : undefined,
        for_review_reason_text: item.newStatus === statuses.forReview ? item.for_review_reason_text : undefined,
        image_ids: item.newStatus !== statuses.accepted ? item?.images?.map(image => image.id) || [] : [],
      })),
    accept_remaining_items: false,
    issue_refund: issueRefund,
    restock: numberOfNewAcceptedItems > 0 ? restock : false,
    restock_location_id: restockLocation,
    issue_exchange_order_processing: issueExchangeOrderProcessing,
  }

  if (shouldSendModifications) {
    payload.modifications = {
      note: note || 'refund',
      refund_method: totalAmount > 0 ? refundMethod : null,
      ...getConceptAmountsPayload(concepts),
    }
  }

  return payload
}

export const getRejectionWarningMessage = (isInstant, numberOfNewRejectedItems) => {
  if (isInstant && numberOfNewRejectedItems > 0) return rejectionWarningMessages.instant

  return rejectionWarningMessages.generic
}

export const getEditTransactionResultMenuItems = ({ label, canEditTransactionTotal, onClick }) => {
  if (!canEditTransactionTotal) return []

  return [
    {
      label: (
        <Styles.MenuItem>
          <PencilSimpleIcon /> {label}
        </Styles.MenuItem>
      ),
      onClick,
    },
  ]
}
